import styled, { css } from 'styled-components';

interface TextProps {
  secondary?: boolean;
  includeDivider?: boolean;
  large?: boolean;
}

export const Text = styled.p<TextProps>`
  color: #352e27;
  font-weight: 500;

  span {
    color: #352e27;
    font-weight: bold;
  }

  ${({ large }) =>
    large &&
    css`
      font-size: larger;
    `}

  ${({ includeDivider }) =>
    includeDivider &&
    css`
      padding-bottom: 12px;
      border-bottom: 1px solid #ccc;
    `}

  ${({ secondary }) =>
    secondary &&
    css`
      color: #777;
    `}
`;
